export default __webpack_public_path__ + "static/routines-c6e1aa524fe260ee1014d0e8fd8b97c6.mp4";